<template>
  <div class="report-comp-bd ubv">
    <div class="header">
      <el-radio-group v-model="formSearch.reportType" @change="onTypeChange">
        <el-radio-button :label="item.value" v-for="(item, index) in reportTypeData" :key="index">{{ item.label }}</el-radio-button>
      </el-radio-group>
      <div class="ub" style="float: right">
        <div style="width: 380px; text-align: right; margin-left: auto">
          <!-- 天 -->
          <custom-date-picker
            v-show="formSearch.reportType === 0"
            v-model="dateTimes"
            :init-value="initValue"
            type="daterange"
            align="right"
            unlink-panels
            value-format="YYYY-MM-DD HH:mm:ss"
            @init="onTypeChange"
            @change="onTypeChange"
            :clearable="false"
            :start-placeholder="$t('Common.com_start_date')"
            :end-placeholder="$t('Common.com_end_date')"
            :picker-options="beforeToday2016"
          ></custom-date-picker>
          <!-- 历史报表 -->
          <!-- 年 -->
          <year-picker v-show="formSearch.reportType === 1" v-model="reportYearTime" class="year-picker" @change="onTypeChange"></year-picker>
          <!-- 季度 -->
          <season-picker v-show="formSearch.reportType === 2" v-model="reportSeasonTime" ref="jidupicker" class="season-picker" @change="onTypeChange"></season-picker>
          <!-- 月 -->
          <el-date-picker
            v-show="formSearch.reportType === 3"
            v-model="reportMonthTime"
            type="monthrange"
            range-separator="—"
            :format="$getElFormat('yyyy-MM', true)"
            value-format="yyyy-MM"
            align="right"
            placeholder=""
            :picker-options="pickerOptionsIntervalThreeYears"
            :clearable="false"
            @change="onTypeChange"
            :start-placeholder="$t('Common.com_start_month')"
            :end-placeholder="$t('Common.com_end_month')"
          ></el-date-picker>
          <!--周 -->
          <week-picker v-show="formSearch.reportType === 4" v-model="reportWeekTime" class="week-picker" @change="onTypeChange"></week-picker>
        </div>
        <div style="margin-left: 16px">
          <search-input :placeholder="$t('Common.com_serial_no')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </div>
        <div style="margin-left: 16px">
          <el-button type="info" @click="onExport">
            <i class="icon icon-export-excel"></i>
            {{ $t('Common.com_export') }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="table-bd">
      <!-- 美国站是ft² -->
      <custom-table
        v-if="formSearch.reportType === 0 && isUs"
        tableCode="portal_device_log_ft"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        :onlyArr="['reportDate', 'productCode', 'bodyNum', 'manualUsageTimeFormat', 'manualCleanArea', 'autonomousCleanArea', 'autonomousUsageTimeFormat', 'locationName', 'siteName', 'city']"
        :slots="['reportDate', 'manualCleanArea', 'autonomousCleanArea', 'trainingCleanArea']"
        :filterArr="filterArr"
      >
        <template v-slot:reportDate="scope">
          <span>{{ $moment(scope.row.reportDate).format('MM/DD/YYYY') }}</span>
        </template>
        <template v-slot:manualCleanArea="scope">
          <span>{{ $formatLenLocal(scope.row.manualCleanArea) }}</span>
        </template>
        <template v-slot:autonomousCleanArea="scope">
          <span>{{ $formatLenLocal(scope.row.autonomousCleanArea) }}</span>
        </template>
        <template v-slot:trainingCleanArea="scope">
          <span>{{ $formatLenLocal(scope.row.trainingCleanArea) }}</span>
        </template>
      </custom-table>
      <custom-table
        v-if="formSearch.reportType === 0 && !isUs"
        tableCode="portal_device_log"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        :onlyArr="['reportDate', 'productCode', 'bodyNum', 'manualUsageTimeFormat', 'manualCleanArea', 'autonomousCleanArea', 'autonomousUsageTimeFormat', 'locationName', 'siteName', 'city']"
        :filterArr="filterArr"
      ></custom-table>
      <!-- 美国站是ft² -->
      <custom-table
        v-if="formSearch.reportType !== 0 && isUs"
        tableCode="portal_device_log_date_ft"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        :onlyArr="['reportDate', 'productCode', 'bodyNum', 'manualUsageTimeFormat', 'manualCleanArea', 'autonomousCleanArea', 'autonomousUsageTimeFormat', 'locationNameTotal', 'siteName', 'city']"
        :slots="['attendanceRate','averageCleanArea','actualCleanArea','totalCleanArea','totalManualAveClean','manualAveValue','totalAutoAveClean','autoAveClean','manualCleanArea', 'autonomousCleanArea', 'trainingCleanArea']"
        :filterArr="filterArr"
      >
        <template v-slot:attendanceRate="scope">
          <span :style="getAttendanceColor(scope.row.attendanceRate)">{{scope.row.attendanceRate}}</span>
        </template>
        <template v-slot:averageCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.averageCleanArea)}}</span>
        </template>
        <template v-slot:actualCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.actualCleanArea)}}</span>
        </template>
        <template v-slot:totalCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.totalCleanArea)}}</span>
        </template>
        <template v-slot:totalManualAveClean="scope">
          <span>{{$formatLenLocal(scope.row.totalManualAveClean)}}</span>
        </template>
        <template v-slot:manualAveValue="scope">
          <span>{{$formatLenLocal(scope.row.manualAveValue)}}</span>
        </template>
        <template v-slot:totalAutoAveClean="scope">
          <span>{{$formatLenLocal(scope.row.totalAutoAveClean)}}</span>
        </template>
        <template v-slot:autoAveClean="scope">
          <span>{{$formatLenLocal(scope.row.autoAveClean)}}</span>
        </template>
        <template v-slot:manualCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.manualCleanArea)}}</span>
        </template>
        <template v-slot:autonomousCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.autonomousCleanArea)}}</span>
        </template>
        <template v-slot:trainingCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.trainingCleanArea)}}</span>
        </template>
      </custom-table>
      <custom-table
        v-if="formSearch.reportType !== 0 && !isUs"
        tableCode="portal_device_log_date"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        :onlyArr="['reportDate', 'productCode', 'bodyNum', 'manualUsageTimeFormat', 'manualCleanArea', 'autonomousCleanArea', 'autonomousUsageTimeFormat', 'locationNameTotal', 'siteName', 'city']"
        @filter="filterChange"
        :filterArr="filterArr"
      ></custom-table>
    </div>
    <div class="page-footer">
      <custom-pagination :radius="false" :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import seasonPicker from '@/components/quarterlyRangePicker.vue';
import yearPicker from '@/components/yearRangePicker.vue';
import weekPicker from '@/components/weekRangePicker.vue';

export default {
  name: 'report',
  components: {
    seasonPicker,
    yearPicker,
    weekPicker,
  },
  computed: {
    reportTypeData() {
      return [
        {
          label: this.$t('dashboard_report.ri'),
          value: 0,
        },
        {
          label: this.$t('dashboard_report.zhou'),
          value: 4,
        },
        {
          label: this.$t('dashboard_report.yue'),
          value: 3,
        },
        {
          label: this.$t('dashboard_report.ji'),
          value: 2,
        },
        {
          label: this.$t('dashboard_report.nian'),
          value: 1,
        },
      ];
    },
    filterArr() {
      if (this.isCoJv) {
        return ['bigCustomerName'];
      }
      return ['customerName', 'bigCustomerName'];
    },
  },
  data() {
    return {
      provide: true,
      formSearch: {
        reportType: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        bodyNum: '',
        productCode: '',
        productName: '',
        locationId: '',
        locationName: '',

        // region: '',
        locationAddress: '',
        afterServiceName: '',
        agentCoName: '',
        customerName: '',

        beginTime: '',
        endTime: '',
        countryCode: '',
        provinceCode: '',
        cityCode: '',
        country: '',
        province: '',
        city: '',
        tagName: '',
      },
      tagId: '',
      tags: [],
      // 日
      initValue: '',
      dateTimes: '',
      reportYearTime: [`${moment(this.$getLocalTime()).year()}`, `${moment(this.$getLocalTime()).year()}`],
      reportSeasonTime: [`${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`, `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`],
      reportMonthTime: [`${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`, `${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`],
      reportWeekTime: [this.$momentElLocal(moment().week(moment().week())), this.$momentElLocal(moment().week(moment().week()))],
      tableList: [],
      totalRows: 0,
      // 选择日期配置
      pickerOptionDisAfter: {
        shortcuts: [
          {
            text: this.$t('dashboard_report.zui_jin_yi_zhou'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('dashboard_report.zui_jin_yi_ge_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('dashboard_report.zui_jin_san_ge_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day'),
      },
      // 日期选择范围在三年内
      pickerOptionsIntervalThreeYears: {
        firstDayOfWeek: 1,
        onPick: (time) => {
          // 当选择了第一个日期时，记录起始日期
          if (time.minDate && !time.maxDate) {
            this.IntervalThreeYearsStartDate = time.minDate.getTime();
          }
          // 如果选择了第二个日期，则清空起始日期
          if (time.maxDate) {
            this.IntervalThreeYearsStartDate = null;
          }
        },
        disabledDate: (time) => {
          const currentTime = Date.now(); // 当前时间戳
          const timeStamp = time.getTime(); // 当前选中的日期时间戳
          // 添加2016年1月1日的时间戳
          const minYearLimit = moment(this.$momentElLocal(moment('2016-01-01 00:00:00'))).valueOf();
          if (this.IntervalThreeYearsStartDate) {
            // 计算允许的最大和最小日期（3年范围）
            const limitRange = 3 * 365 * 24 * 3600 * 1000; // 3年转化为毫秒
            const maxTime = this.IntervalThreeYearsStartDate + limitRange;
            const minTime = this.IntervalThreeYearsStartDate - limitRange;

            // 禁用超过 3 年范围、未来的日期或2016年之前的日期
            return (
              timeStamp > maxTime // 超过最大日期
        || timeStamp < minTime // 小于最小日期
        || timeStamp > currentTime // 禁止未来日期
        || timeStamp < minYearLimit // 禁止2016年之前的日期
            );
          } else {
            // 如果未选择第一个日期，则禁用未来的日期或2016年之前的日期
            return timeStamp > currentTime || timeStamp < minYearLimit;
          }
        },
      },

      isFilter: false,
    };
  },

  mounted: function () {
    this.initValue = [this.$moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 00:00:00'), this.$moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59')];
    this.formSearch.beginTime = this.dateTimes ? this.dateTimes[0] : '';
    this.formSearch.endTime = this.dateTimes ? this.dateTimes[1] : '';
    // this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 获取列表
    getTableList() {
      // this.formSearch.beginTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[0] : '';
      // this.formSearch.endTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[1] : '';

      if (this.formSearch.reportType === 0) {
        this.$getJSON(apis.portalDeviceReportDailyPage, { ...this.formSearch,
          startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD')
        })
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      } else {
        // 清空 没有的筛选
        // this.formSearch.region = '';
        this.formSearch.locationAddress = '';
        this.formSearch.countryCode = '';
        this.formSearch.provinceCode = '';
        this.formSearch.cityCode = '';
        this.formSearch.country = '';
        this.formSearch.province = '';
        this.formSearch.city = '';
        this.formSearch.tagName = '';
        this.$getJSON(apis.portalDeviceReportSummaryPage, this.formSearch)
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      }
    },
    // 获取季度
    getSeason: function (month) {
      if (month < 3) {
        return '01';
      } else if (month < 6) {
        return '02';
      } else if (month < 9) {
        return '03';
      } else if (month < 12) {
        return '04';
      }
      return true;
    },
    onTypeChange() {
      switch (this.formSearch.reportType) {
        case 1:
          this.formSearch.beginTime = this.reportYearTime ? this.reportYearTime[0] : '';
          this.formSearch.endTime = this.reportYearTime ? this.reportYearTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 2:
          this.formSearch.beginTime = this.reportSeasonTime ? this.reportSeasonTime[0] : '';
          this.formSearch.endTime = this.reportSeasonTime ? this.reportSeasonTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 3:
          this.formSearch.beginTime = this.reportMonthTime ? this.reportMonthTime[0] : '';
          this.formSearch.endTime = this.reportMonthTime ? this.reportMonthTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 4:
          // 设置周的开始时间是星期一 1月1号是年开始的第一周
          moment.updateLocale('en', {
            week: {
              // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
              dow: 1, // Monday is the first day of the week.
              doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
            },
          });
          this.formSearch.beginTime = this.reportWeekTime.length ? moment(this.reportWeekTime[0]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.formSearch.endTime = this.reportWeekTime.length ? moment(this.reportWeekTime[1]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.onPageChange({ page: 1 });
          break;
        default:
          this.formSearch.beginTime = this.dateTimes.length ? this.dateTimes[0] : '';
          this.formSearch.endTime = this.dateTimes.length ? this.dateTimes[1] : '';
          this.onPageChange({ page: 1 });
      }
    },
    // 获取标列表
    getTagsList(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.tagId === item.tagId);
        if (!isHas && item.tagId && item.tagName) {
          arr.push({
            tagId: item.tagId,
            tagName: item.tagName,
          });
        }
      });
      this.tags = arr;
    },
    // 点击标签
    onItemTag(tagId) {
      if (tagId === this.tagId) {
        this.tagId = '';
      } else {
        this.tagId = tagId;
      }
    },
    clearTag(key, name, index) {
      this.formSearch[key].splice(index, 1);
      this.formSearch[name].splice(index, 1);
      this.onPageChange({ page: 1 });
    },
    onClear() {
      this.formSearch.bodyNum = '';
      this.formSearch.productCode = '';
      this.formSearch.productName = '';
      this.formSearch.locationName = '';
      this.formSearch.locationId = '';
      this.formSearch.region = '';
      this.formSearch.locationAddress = '';
      this.formSearch.afterServiceName = '';
      this.formSearch.agentCoName = '';
      this.formSearch.beginTime = '';
      this.formSearch.endTime = '';
      this.formSearch.countryCode = '';
      this.formSearch.provinceCode = '';
      this.formSearch.cityCode = '';

      this.formSearch.tagName = '';
      this.dateTimes = [];
      // this.initValue = [this.$moment().subtract(1, 'day').format('YYYY-MM-DD 00:00:00'), this.$moment().format('YYYY-MM-DD 23:59:59')];
      this.initValue = [];
      this.reportYearTime = [];
      this.reportSeasonTime = [];
      this.reportMonthTime = [];
      this.reportWeekTime = [];
      // initValue会调用到
      // this.onPageChange({ page: 1 });
    },
    // 过滤图标
    dataFilter: function (list) {
      if (!this.tagId) {
        return list;
      }
      return list.filter(t => t.tagId === this.tagId);
    },

    onExport: function () {
      if (this.formSearch.reportType === 0) {
        this.exportTable('portalDeviceReportDailyExport', {
          ...this.formSearch,
          startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD'),
          platform: 'portal',
          includeColumnList: [
            'reportDate',
            'productCode',
            'bodyNum',
            'manualUsageTimeFormat',
            'manualCleanArea',
            'autonomousCleanArea',
            'autonomousUsageTimeFormat',
            'locationName',
            'siteName',
            'city',
          ],
        });
      } else {
        this.exportTable('portalDeviceReportSummaryExport', {
          ...this.formSearch,
          platform: 'portal',
          includeColumnList: [
            'reportDate',
            'productCode',
            'bodyNum',
            'manualUsageTimeFormat',
            'manualCleanArea',
            'autonomousCleanArea',
            'autonomousUsageTimeFormat',
            'locationNameTotal',
            'siteName',
            'city',
          ],
        });
      }
    },
    getAttendanceColor(rate) {
    // 提取百分比值中的数字部分
      const value = parseFloat(rate);
      if (typeof value !== 'number') {
        return {};
      }
      // 根据条件返回不同的颜色样式
      if (value >= 90) {
        return { color: '#4CAF50' }; // 绿色
      } else if (value >= 70 && value < 90) {
        return { color: '#FFC107' }; // 黄色
      } else {
        return { color: '#F44336' }; // 红色
      }
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    dataFilterTree: function (list, code) {
      // 要过滤第一层 那children那层
      if (list.length > 0 && list[0].code === code) {
        const node = list[0];
        return node && node.children ? node.children : [];
      } else {
        return list;
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.report-comp-bd {
  height: 100%;
  .header {
    padding: 24px;

    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 20px 0 0 20px;
    }
    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 20px 20px 0;
    }
    .week-picker,
    .season-picker,
    .year-picker {
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 47% !important;
        &:last-of-type {
          float: right;
        }
      }
    }

    .season-picker {
      display: flex;
      justify-content: space-between;
      .quarter-picker {
        width: 47% !important;
        .el-input {
          width: 100% !important;
        }
        &:last-of-type {
          float: right;
        }
      }
    }
  }
  .table-bd {
    // height: 328px;
    flex: 1;
    padding: 0 24px;
  }
  .page-footer {
    height: 88px;
  }
}
</style>
